import React from 'react'

export default function Eroor() {
  return (
    <div>
      <h1>Error ...........Page not found 404</h1>
    </div>
  )
}
